import CONTRACT_ACTIONS from '../actions/contractActions'


export default function reducer(state, action){
  switch(action.type){
    case CONTRACT_ACTIONS.SET_CONTRACT_VALUES:
      return {
        ...state,
        ...action.value
      }
    case CONTRACT_ACTIONS.SET_CONTRACT_INFO:
      return {
        ...state,
        ...action.value
      }
    case CONTRACT_ACTIONS.SET_DATE:
      return {
        ...state,
        date: action.value
      }
    case CONTRACT_ACTIONS.SET_USERS:
      return {
        ...state,
        users: action.value
      }
    case CONTRACT_ACTIONS.CHECK_INSURANCE:
      return {
        ...state,
        insurance: {
          ...state.insurance,
          isLoading: true
        }
      }
    case CONTRACT_ACTIONS.CHECK_INSURANCE_SUCCESSFULLY_CREATED:
      return {
        ...state,
        insurance: {
          ...state.insurance,
          id: action.value
        }
      }
    case CONTRACT_ACTIONS.CHECK_INSURANCE_SUCCESSFULLY_CHECKED:
      return {
        ...state,
        insurance: {
          ...state.insurance,
          ...action.value,
          isLoading: false
        }
      }
    case CONTRACT_ACTIONS.RETRY_INSURANCE_CHECK:
      return {
        ...state,
        insurance: {
          ...state.insurance,
          status: '',
          isLoading: true
        }
      }
    case CONTRACT_ACTIONS.TIMEOUT_INSURANCE_CHECK:
      return {
        ...state,
        insurance: {
          ...state.insurance,
          status: '',
          isLoading: false
        }
      }
    case CONTRACT_ACTIONS.SET_OWNED_PROPERTIES:
      return {
        ...state,
        properties: {
          ...state.properties,
          total: action.value,
        }
      }
    case CONTRACT_ACTIONS.SET_INITIAL_FETCH:
      return {
        ...state,
        properties: {
          ...state.properties,
          fetched: action.value,
        }
      }
    case CONTRACT_ACTIONS.SET_PROPERTIES:
      return {
        ...state,
        properties: {
          ...state.properties,
          data: action.value,
        }
      }
    case CONTRACT_ACTIONS.ANNOUNCE_PROPERTY:
    case CONTRACT_ACTIONS.SET_CONTRACT_ID:
      return {
        ...state,
        propertyId: action.value
      }
    default: 
      return state;
  }
};

export const contractInitialState = {
  values: {
    rent: 0,
    condo: 0,
    iptu: 0,
    other: 0
  },
  tenant_pays: {
    rent: true,
    condo: true,
    iptu: true,
    other: true
  },
  address: {
    neighbourhood: '',
    number: '',
    street: '',
    complement: '',
    zip_code: '',
  },
  info: {
    type: '',
    area: 0,
    rooms: 0,
    bathrooms: 0,
    car_slots: 0
  },
  users: [],
  insurance: {
    isLoading: false,
    id: '',
    status: '',
    insurer: 'REFUSED',
  },
  propertyId: '',
  properties: {
    data: [],
    total: 0,
    fetched: false
  }
}